import { Component, inject } from '@angular/core';

import { MatDialogRef } from '@cds/ng-web-components/popup';
import { CdTextareaModule } from '../../../../shared/cd-textarea/cd-textarea.module';
import { CdsButtonModule } from '@cds/ng-web-components/button';
import { CdsLanguageModule } from '@cds/ng-core/lang';

@Component({
  selector: 'app-add-to-item',
  templateUrl: './add-to-item.component.html',
  styleUrls: ['./add-to-item.component.scss'],
  imports: [CdTextareaModule, CdsButtonModule, CdsLanguageModule],
})
export class AddToItemComponent {
  private dialogRef = inject<MatDialogRef<AddToItemComponent>>(MatDialogRef);

  text = '';

  continue() {
    if (this.disabledContinue) {
      return;
    }

    this.dialogRef.close(this.text);
  }

  cancel() {
    this.dialogRef.close();
  }

  get disabledContinue() {
    return this.text.length === 0;
  }
}
